class HelpController {
  constructor ($window, $state, $log, I18n, Localization, VehicleService, MetricsService) {
    'ngInject'
    this.$log = $log
    this.$state = $state
    this.$window = $window
    this.I18n = I18n
    this.Localization = Localization
    this.VehicleService = VehicleService
    this.metricsService = MetricsService
    this.init()
  }

  init () {
    this.gdprLink = this.Localization.getLocalizedAppConfig().gdprLink
    if (this.gdprLink) {
      this.$log.debug('GDPR link: ' + this.gdprLink)
    } else {
      this.$log.debug('No GDPR link found')
    }

    this.VehicleService.getCurrentSelectedVehicle()
    .then((vehicle) => {
      // Get the current vehicle or the first in list if not set
      if (!vehicle) {
        this.$log.debug('No vehicle found. Redirecting to my garage')
        return this.$state.go('profile.myGarage')
      }
    }, () => {
      this.$log.error('No vehicle found. Redirecting to my garage')
      return this.$state.go('profile.myGarage')
    })
  }
}

export default HelpController



// WEBPACK FOOTER //
// ./src/app/pages/help/help.controller.js